// extracted by mini-css-extract-plugin
module.exports = {"container":"QuestionnaireList_container__3ubaf","createSurvey":"QuestionnaireList_createSurvey__1dKFw"};